<script>
import store from '@state/store'
import ModalRemoverAtivo from '@modal/remover-ativo'
import con from '@connection'
import { claimLatestRequest } from '@modules/consolidator/utils/Api/Api'
import {
  minhaCarteira,
  resgateTotal,
  aporte,
  configuracoes,
} from '@constants/URL'
import { apiConsolidatorCarteiraAtivos } from '@modules/consolidator/api/apiConsolidatorCarteiraAtivos'
import { apiConsolidatorSuggestions } from '@modules/consolidator/api/apiConsolidatorSuggestions'
import {
  idsDosAtivos,
  pendentesPorAtivo,
  pendentesPorMovimentacao,
} from '@modules/consolidator/utils/suggestions-fila/suggestions-fila'
import { indexarMovimentacoes } from '@modules/consolidator/utils/suggestion-to-movimentacao/suggestion-to-movimentacao'
import { idDaCarteira } from '@modules/consolidator/utils/cliente-da-carteira/cliente-da-carteira'
import { apiClients } from '@modules/professionals/api/apiClients'
import { apiPortfolioPortfolioModels } from '@modules/portfolio/api/apiPortfolioPortfolioModels'
import { getEditDescriptor } from '@modules/crm/utils/summaryEditableFields'
import { podeCurarSugestoesIa } from '@modules/consolidator/utils/suggestions-acesso/suggestions-acesso'
import { ACAO_SUGESTOES_IA } from '@modules/consolidator/utils/wallet-alerts-catalog/wallet-alerts-catalog'
import { openClientSuggestions } from '@modules/consolidator/utils/asset-row-actions/asset-row-actions'
import { apiConsolidatorWalletAnalysis } from '@modules/consolidator/api/apiConsolidatorWalletAnalysis'
import { apiConsolidatorAssetSeries } from '@modules/consolidator/api/apiConsolidatorAssetSeries'
import { apiConsolidatorStatisticsPerAsset } from '@modules/consolidator/api/apiConsolidatorStatisticsPerAsset'
import { buildWalletAnalysisRequest } from '@modules/consolidator/utils/build-wallet-analysis-request/build-wallet-analysis-request'
import { buildGroupBreakdownRequest } from '@modules/consolidator/utils/build-group-breakdown-request/build-group-breakdown-request'
import {
  formatRentabilityChart,
  getAvailableBenchmarkNames,
} from '@modules/consolidator/utils/format-rentability-chart/format-rentability-chart'
import { formatPatrimonialChart } from '@modules/consolidator/utils/format-patrimonial-chart/format-patrimonial-chart'
import { formatInstitutionDistribution } from '@modules/consolidator/utils/format-institution-distribution/format-institution-distribution'
import {
  formatAlocacaoEstrategicaChart,
  formatSuggestedAllocations,
  buildClassColorMap,
} from '@modules/consolidator/utils/format-alocacao-estrategica-chart/format-alocacao-estrategica-chart'
import {
  formatAllocationStatistics,
  formatAllocationSuitability,
  formatAllocationVol,
  buildAllocationRentMap,
  buildAllocationRows,
} from '@modules/consolidator/utils/format-detalhamento-alocacao-estrategica/format-detalhamento-alocacao-estrategica'
import { formatLookthroughClasses } from '@modules/consolidator/utils/format-lookthrough-classes/format-lookthrough-classes'
import { buildAssetGroups } from '@modules/consolidator/utils/build-asset-groups/build-asset-groups'
import { resolvePosicaoPlTotal } from '@modules/consolidator/utils/posicao-pl-fallback/posicao-pl-fallback'
import { formatWelcomeCardData } from '@modules/consolidator/utils/format-welcome-card-data/format-welcome-card-data'
import { buildLegacyStatsShape } from '@modules/consolidator/utils/adapt-wallet-analysis-response/adapt-wallet-analysis-response'
import { formatStatisticsCard } from '@modules/consolidator/utils/format-statistics-card/format-statistics-card'
import { resolveAssetGroupKey } from '@modules/consolidator/utils/resolve-asset-group-key/resolve-asset-group-key'
import {
  buildAnbimaFracoesFromRisk,
  buildAnbimaMaxFromRisk,
  resolveDesenquadramentoStatus,
} from '@modules/consolidator/utils/build-desenquadramento-data/build-desenquadramento-data'
import { apiConsolidatorClientAssets } from '@modules/consolidator/api/apiConsolidatorClientAssets'
import {
  computeBulkFlagTarget,
  getBulkActionLabel,
  buildApplyFlagRequest,
} from '@modules/consolidator/utils/bulk-flag-action/bulk-flag-action'
import Vue from 'vue'
import {
  MODAL,
  MODAL_IMPORT,
  RELOAD,
  tipos,
  OPCOES_FILTRO_DATA,
  BLACK_LIST_CALCULO_RENTABILIDADE,
} from '@constants/Text'
import { resolverClientePorId } from '@utils/cliente-por-id/cliente-por-id'
import { SUGESTOES_IA_VIEW } from '@modules/consolidator/constants/Text'
import { GlobalBus } from '@services/bus'
import {
  toPercent,
  getCorretoraSimple,
  toMoney,
  getNumber,
  formatNumber,
  possivelJSON,
} from '@utils/Format'
import { CLIENT_BENCHMARK_KEY } from '@utils/clienteBenchmark'
import { hasIncompleteAssets } from '@modules/consolidator/utils/HasIncompleteAssets/HasIncompleteAssets.js'
import { normalizeAssetType } from '@modules/consolidator/utils/resolve-asset-edit/resolve-asset-edit.js'
import {
  WALLET_STANDALONE_FILTER_KEYS,
  applyWalletFilterDefaults,
  resolveStandaloneFilterKeys,
} from '@modules/consolidator/utils/normalize-wallet-filters/normalize-wallet-filters'
import { buildGroupLabelMap } from '@modules/consolidator/utils/wallet-modo-configs/wallet-modo-configs'
import { hasWalletData } from '@modules/consolidator/utils/has-wallet-data/has-wallet-data'
import { extractClientWalletDates } from '@modules/consolidator/utils/extract-client-wallet-dates/extract-client-wallet-dates'
import ResgateTotal from '@modal/resgate-total-contas-automaticas'
import DetailsAsset from '@modules/consolidator/modal/details-asset/details-asset'
import AcoesLote from '@components/acoes-lote'
import ModalAcoesLoteAtivos from '@modal/acoes-lote-ativos-consolidador'
import InfoCarteira from '@modules/consolidator/components/info-carteira/info-carteira.vue'
import Evolucao from '@modules/consolidator/components/evolucao/evolucao.vue'
import MercadoIndicadores from '@modules/consolidator/components/mercado-indicadores/mercado-indicadores.vue'
import Estatisticas from '@modules/consolidator/components/estatisticas/estatisticas.vue'
import Distribuicao from '@modules/consolidator/components/distribuicao/distribuicao.vue'
import AlocacaoEstrategica from '@modules/consolidator/components/alocacao-estrategica/alocacao-estrategica.vue'
import DetalhamentoAlocacaoEstrategica from '@modules/consolidator/components/detalhamento-alocacao-estrategica/detalhamento-alocacao-estrategica.vue'
import DetalhamentoCarteiraAtivos from '@modules/consolidator/components/carteira-ativos/carteira-ativos.vue'
import WalletEmptyState from '@modules/consolidator/components/wallet-empty-state/wallet-empty-state.vue'
import { GRUPO_FAMILIAR_ORIGEM } from '@modules/crm/constants/GrupoFamiliar'
import ConsolidatorSelectClient from '@modules/consolidator/modal/select-client/select-client.vue'
import RemoverProduto from '@modules/consolidator/modal/remover-produto/remover-produto.vue'
import ConditionalTeleport from '@components/teleport/conditional-teleport.vue'
import WalletFilters from '@modules/consolidator/components/wallet-filters/wallet-filters.vue'
import { walletFilters } from '@modules/consolidator/constants/filtros'
import { REPORT_PALETTE } from '@modules/consolidator/constants/Color'
import { apiConsolidatorGroupWalletAnalysis } from '@modules/consolidator/api/apiConsolidatorGroupWalletAnalysis'
import GroupWalletTable from '@modules/consolidator/components/group-wallet-table/group-wallet-table.vue'
import {
  resolveGroupMemberRows,
  resolveGroupMembers,
} from '@modules/consolidator/utils/group-member-rows/group-member-rows'
import { resolveGroupBenchmarkLabel } from '@modules/consolidator/utils/group-wallet-labels/group-wallet-labels'
import { enrichWalletWithMembers } from '@modules/consolidator/utils/enrich-wallet-with-members/enrich-wallet-with-members'
import GenericOverviewDonutChart from '@modules/consolidator/components/generic-overview-donut-chart/generic-overview-donut-chart.vue'
import {
  buildGroupAccountDistribution,
  buildGroupMemberPlRows,
} from '@modules/consolidator/utils/build-group-wallet-rows/build-group-wallet-rows'
import WalletAlerts from '@modules/consolidator/components/wallet-alerts/wallet-alerts.vue'
import OrphanAssetsWarnings from '@modules/consolidator/components/orphan-assets-warnings/orphan-assets-warnings.vue'
import { decimalLengthPU } from '@utils/Asset'
import { apiSettingsBenchmarks } from '@modules/settings/api/apiSettingsBenchmarks'
import ModalClientsCarteiraAdministrada from '@modules/clients/modal/carteira-administrada/clients-carteira-administrada'
import Tour from '@modules/global/components/tour/tour.vue'
import OptionsTourManual from '@modules/settings/components/options-tour-manual/options-tour-manual.vue'
import { whatsnewTourMixin } from '@modules/global/mixins/whatsnew-tour-mixin'
import {
  CARTEIRA_MINHA_WHATSNEW_STEPS,
  CARTEIRA_MINHA_WHATSNEW_TARGETS,
} from '@modules/consolidator/constants/whatsnew'
import { PAGE_HEADER_WHATSNEW } from '@modules/global/constants/whatsnew'
import { resolveWalletScope } from '@modules/consolidator/utils/wallet-scope/wallet-scope'
import {
  GROUP_ACCOUNT_DISTRIBUTION_BASE_KEY,
  GROUP_ASSET_COLUMN_CONFIG,
  GROUP_ASSET_ROW_ACTIONS,
} from '@modules/consolidator/constants/group-wallet'
import { WALLET_ASSET_COLUMN_CONFIG } from '@modules/consolidator/constants/wallet-asset-columns'

export default {
  page: {
    title: 'Minha Carteira',
    meta: [{ name: 'description', content: 'MinhaCarteira' }],
  },
  components: {
    ModalRemoverAtivo,
    RemoverProduto,
    ConditionalTeleport,
    DetailsAsset,
    ResgateTotal,
    AcoesLote,
    ModalAcoesLoteAtivos,
    InfoCarteira,
    Evolucao,
    MercadoIndicadores,
    Estatisticas,
    Distribuicao,
    AlocacaoEstrategica,
    DetalhamentoAlocacaoEstrategica,
    DetalhamentoCarteiraAtivos,
    ModalClientsCarteiraAdministrada,
    WalletEmptyState,
    ConsolidatorSelectClient,
    WalletFilters,
    GroupWalletTable,
    GenericOverviewDonutChart,
    WalletAlerts,
    OrphanAssetsWarnings,
    Tour,
    OptionsTourManual,
  },
  mixins: [whatsnewTourMixin],
  props: {
    clienteModal: {
      type: Object,
      default: null,
    },
    bus: {
      type: Object,
      default: null,
    },
    busLeft: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      scrollBottomInterval: null,
      scrollBottomTimeout: null,
      SCROLL_BOTTOM_POLL_MS: 500,
      SCROLL_BOTTOM_MAX_WAIT_MS: 5000,
      OPCOES_FILTRO_DATA,
      walletFilters,
      mapper_benchmarks: {},
      tipos: tipos,
      store: store,
      busModal: new Vue(),
      loading: false,
      pendingReload: null,
      walletLoadRegistry: {},
      loadingClients: false,
      sugestoesPendentesPorAtivo: null,
      // Ativos planos vindos do `carteira-ativos` (o unico lugar que carrega o NOME). O painel de
      // sugestoes usa para nomear o card de cadastro e para achar o alvo do "Editar e aceitar".
      ativosDaCarteira: [],
      // Pedido de recarga que chegou com outra em voo. Ver `carregarSugestoesIa`.
      sugestoesDesatualizadas: false,
      sugestoesPorMovimentacao: null,
      movimentacoesDasSugestoes: null,
      sugestoesDaFila: null,
      carregandoSugestoes: false,
      perfilDoCliente: null,
      nomeCadastralDoCliente: null,
      perfilDoClienteCarregado: false,
      corretoras: [],
      lista_mapper_benchmark: [],
      benchmarksSelecionados: [],
      lineBenchmarks: [],
      CLIENT_BENCHMARK_KEY,
      lineChart: {
        labels: [],
        datasets: [],
      },
      carteira: {},
      tiposChart: {},
      classes: [],
      corretorasPie: [],
      corretorasPercent: [],
      corretorasOpts: {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return toMoney(value)
            },
          },
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: '80%',
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  offsetY: -15,
                  formatter: (v) => {
                    return toMoney(v)
                  },
                },
                total: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  show: true,
                  formatter: (w) => {
                    return toMoney(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0)
                    )
                  },
                },
              },
            },
          },
        },
      },
      composicao: [],
      estatisticas: [],
      composicaoOpts: {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return toMoney(value)
            },
          },
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: '80%',
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  offsetY: -15,
                  formatter: (v) => {
                    return toMoney(v)
                  },
                },
                total: {
                  fontSize: '12px',
                  fontFamily: 'Geist',
                  show: true,
                  formatter: (w) => {
                    return toMoney(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0)
                    )
                  },
                },
              },
            },
          },
        },
      },
      recebendoEditar: {},
      ativoAdd: {},
      hasAssetsAutomatic: false,
      first_login: false,
      id_client_default: '',
      clients: [],
      client_default: {},
      movimentacoes: {},
      liquidez: [],
      alertMarcacaoMercadoRF: {},
      perfil: null,
      ids_ativos_selecionados: [],
      acoes_lote_ativos: [],
      result_fracoes: null,
      resultFracoesClasse: null,
      fundoCompostoExpandido: true,
      classesExpandido: [],
      composicaoOptsExpandido: {},
      composicaoFundos: {},
      classesComComposicao: [],
      mapLinesBenchmarks: {},
      carteirasRecomendadasCliente: [],
    }
  },
  computed: {
    GROUP_ACCOUNT_DISTRIBUTION_BASE_KEY: () =>
      GROUP_ACCOUNT_DISTRIBUTION_BASE_KEY,
    walletScope() {
      return resolveWalletScope({ idCliente: this.id_cliente })
    },
    tabelaDeAtivosSomenteLeitura() {
      return this.usuarioAtual.IS_CLIENTE || this.walletScope.tipo === 'grupo'
    },
    acoesPermitidasNaTabela() {
      if (this.walletScope.tipo !== 'grupo') return null
      return GROUP_ASSET_ROW_ACTIONS
    },
    membrosDoGrupo() {
      return resolveGroupMembers()
    },
    posicaoCompletaDoGrupo() {
      const wallet = this.walletAnalysis
      return (wallet && wallet.posicao_completa) || null
    },
    linhasPorCarteira() {
      return resolveGroupMemberRows()
    },
    benchmarkDoGrupo() {
      const wallet = this.walletAnalysis
      return resolveGroupBenchmarkLabel(wallet && wallet.grupo)
    },
    distribuicaoPorConta() {
      return buildGroupAccountDistribution(
        buildGroupMemberPlRows({
          posicaoCompleta: this.posicaoCompletaDoGrupo,
          membros: this.membrosDoGrupo,
          palette: REPORT_PALETTE,
        })
      )
    },
    ehVisaoDeGrupo() {
      return this.walletScope.viewTipo === 'grupo'
    },
    rotuloAcaoDoGrupo() {
      return this.walletScope.grupo
        ? 'Gerenciar grupo familiar'
        : 'Adicionar grupo familiar'
    },
    iconeAcaoDoGrupo() {
      return this.walletScope.grupo ? 'mdi-account-multiple' : 'plus'
    },
    acoesDoGrupo() {
      if (!this.walletScope.grupo) return []
      const adicionar = {
        label: 'Adicionar grupo familiar',
        icon: 'plus',
        onClick: this.abrirNovoGrupo,
      }
      return [
        {
          label: 'Editar grupo familiar',
          icon: 'edit-2',
          onClick: this.editarGrupoAtual,
        },
        adicionar,
      ]
    },
    colunasDaCarteira() {
      if (this.walletScope.tipo !== 'grupo') return WALLET_ASSET_COLUMN_CONFIG
      return GROUP_ASSET_COLUMN_CONFIG
    },
    // Config do tour "o que mudou" consumida pelo whatsnewTourMixin. Esta é a view
    // viva (carteira.minha) que o menu "Carteiras" abre; espelha a Visão Geral com
    // 2 passos no cabeçalho — filtros e botão de ações. Passos próprios, distintos
    // do redesign (view-carteira-atual.vue) ainda não plugado no nav; a chave de
    // persistência é a compartilhada PAGE_HEADER_WHATSNEW.
    // Cliente final não tem o botão de ações (showWalletActions), então o passo 2
    // apontaria pro alvo vazio — mostra só o passo 1 (filtros) nesse caso.
    whatsnewTourConfig() {
      const isCliente = this.usuarioAtual.IS_CLIENTE
      return {
        ...PAGE_HEADER_WHATSNEW,
        steps: isCliente
          ? [CARTEIRA_MINHA_WHATSNEW_STEPS[0]]
          : CARTEIRA_MINHA_WHATSNEW_STEPS,
        targets: isCliente
          ? [CARTEIRA_MINHA_WHATSNEW_TARGETS[0]]
          : CARTEIRA_MINHA_WHATSNEW_TARGETS,
      }
    },
    enabledWalletFilterKeys() {
      return [
        'modoFiltroCorretora',
        'filtroCorretora',
        ...resolveStandaloneFilterKeys(this.modo_filtro_corretora),
        'investmentTypeFilter',
        'filtroData',
      ]
    },
    menuWalletFilterKeys() {
      return [
        'modoFiltroCorretora',
        'filtroCorretora',
        ...WALLET_STANDALONE_FILTER_KEYS,
        'investmentTypeFilter',
        'filtroData',
      ]
    },
    shouldShowBrokerFilter() {
      return (
        this.viewByFilter === 'corretora' ||
        this.viewByFilter === 'nome_portfolio'
      )
    },
    brokerOrPortfolioLabel() {
      return this.viewByFilter === 'nome_portfolio'
        ? 'Portfólio'
        : 'Instituição'
    },
    alocationDataEstatisticsFromWallet() {
      const stats = formatAllocationStatistics(this.walletAnalysis)
      return this.renameStatsByGroupLabels(stats)
    },
    filteredClassesWithPerfilFromWallet() {
      return buildAllocationRows(
        this.walletAnalysis,
        (name, index) => this.getClassColor(name, index),
        {
          fundoCompostoExpandido: this.fundoCompostoExpandido,
          groupBy: this.modo_filtro_corretora,
          groupLabelByKey: this.groupLabelByKey,
        }
      )
    },
    allocationSuitabilityFromWallet() {
      return formatAllocationSuitability(this.walletAnalysis, {
        fundoCompostoExpandido: this.fundoCompostoExpandido,
      })
    },
    perfilFromWallet() {
      return this.allocationSuitabilityFromWallet.perfil
    },
    statusBalanceamentoFromWallet() {
      return this.allocationSuitabilityFromWallet.statusBalanceamento
    },
    alocacaoClienteInvalidaFromWallet() {
      return this.allocationSuitabilityFromWallet.alocacaoClienteInvalida
    },
    lookthroughClassesFromWallet() {
      return formatLookthroughClasses(this.walletAnalysis)
    },
    carteiraDaTabela() {
      if (this.walletScope.tipo !== 'grupo') return this.walletAnalysis
      return enrichWalletWithMembers(this.walletAnalysis, this.membrosDoGrupo)
    },
    idClienteDonoDosAtivos() {
      if (this.walletScope.tipo === 'grupo') return null
      return this.id_cliente
    },
    carteiraFromWallet() {
      return buildAssetGroups(
        this.carteiraDaTabela,
        (name, index) => this.getClassColor(name, index),
        { idCliente: this.idClienteDonoDosAtivos }
      )
    },
    walletPlTotal() {
      return resolvePosicaoPlTotal(this.walletAnalysis)
    },
    composicaoFundosFromWallet() {
      return (
        (this.walletAnalysis && this.walletAnalysis.composicao_fundos) || {}
      )
    },
    statisticsAssetsFromWallet() {
      return this.$store.getters['consolidator/statisticsPerAsset']
    },
    temFundoCompostoFromWallet() {
      return this.lookthroughClassesFromWallet.hasComposition
    },
    classesComComposicaoFromWallet() {
      return this.lookthroughClassesFromWallet.classesWithComposition
    },
    resultFracoesFromWallet() {
      return (this.walletAnalysis && this.walletAnalysis.suitability) || null
    },
    resultFracoesClasseFromWallet() {
      return (this.walletAnalysis && this.walletAnalysis.suitability) || null
    },
    mapClassRentFromWallet() {
      return buildAllocationRentMap({
        statistics: this.alocationDataEstatisticsFromWallet,
        benchmarks: this.BENCHMARKS,
        mapperBenchmarks: this.mapper_benchmarks,
      })
    },
    BENCHMARKS() {
      return this.$store.getters['settings/benchmarks']
    },
    hasBenchmarks() {
      return Array.isArray(this.BENCHMARKS) && this.BENCHMARKS.length > 0
    },
    ativos_selecionados: {
      get() {
        return this.ids_ativos_selecionados || []
      },
      set(newVal) {
        this.ids_ativos_selecionados = newVal.map((ativo) => {
          if (ativo.id) {
            return ativo.id
          }
          return ativo
        })
      },
    },
    listaAtivosSelecionados() {
      return this.todosAtivosCarteira.filter((ativo) => {
        return this.ativos_selecionados.includes(ativo.id)
      })
    },
    proximaAcaoDesconsiderarVaiMarcar() {
      return computeBulkFlagTarget(
        this.listaAtivosSelecionados,
        'desconsiderar_rentabilidade'
      )
    },
    todosAtivosCarteira() {
      const source = this.carteiraFromWallet
      if (!source) return []
      return Object.values(source)
        .map((item) => item.ativos)
        .flat()
    },
    ativos() {
      return this.todosAtivosCarteira.filter((asset) => {
        return asset['Aplicação'] !== 0
      })
    },
    Color() {
      return this.$store.getters['parameters/colors'] || {}
    },
    allClients() {
      return this.$store.getters['user/allClients'] || []
    },
    clienteAtual() {
      return (
        this.clienteModal || this.$store.getters['user/currentClient'] || {}
      )
    },
    /**
     * O cliente que a URL pede (`/carteiras/atual/c/:id_cliente_route`).
     *
     * String, sempre — `$route.params` não converte —, ou `null` na carteira
     * sem cliente na URL. É a fonte de verdade da US-7: link compartilhado,
     * favorito e F5 têm de abrir a carteira DESTE id, e não a do último cliente
     * que ficou no localStorage.
     */
    idClienteDaRota() {
      return (
        (this.$route && this.$route.params && this.$route.params.id_cliente_route) ||
        null
      )
    },
    viewMode() {
      return this.$store.getters['consolidator/viewMode'] || 'estrategica'
    },
    isDesenquadramentoView() {
      return this.viewMode === 'desenquadramento'
    },
    statusDesenquadramento() {
      return resolveDesenquadramentoStatus(this.walletAnalysis)
    },
    maxAnbimaPorClasse() {
      return buildAnbimaMaxFromRisk(this.walletAnalysis)
    },
    fracoesAnbima() {
      return buildAnbimaFracoesFromRisk(this.walletAnalysis)
    },
    id_cliente() {
      return this.clienteAtual.id || ''
    },
    idClienteApp() {
      return idDaCarteira(this.clienteAtual)
    },
    nomeAtualDoCliente() {
      return (
        this.nomeCadastralDoCliente ||
        this.clienteAtual.nome_cliente ||
        this.clienteAtual.name ||
        ''
      )
    },
    clienteSemPerfil() {
      if (!this.perfilDoClienteCarregado) return false
      return !this.perfilDoCliente
    },
    podeDefinirPerfil() {
      if (this.walletScope.tipo !== 'cliente') return false
      if (this.usuarioAtual.IS_CLIENTE) return false
      return !!this.idClienteApp
    },
    usuarioAtual() {
      return this.$store.getters['user/currentUser'] || {}
    },
    estatistica() {
      return this.statisticsDefaultMetric
    },
    statisticsDefaultMetric() {
      const stats = buildLegacyStatsShape(this.walletAnalysis)
      return formatStatisticsCard(stats['Todos'])
    },
    /**
     * Formatando a carteira do cliente para apresentacao na tabela de ativos.
     * Considerando atributos e filtros.
     */
    carteiraTabela() {
      const carteira = {}
      const group_by = this.modo_filtro_corretora // Tipo, classe, subclasse, corretora
      let plTotal = 0

      this.ativos.forEach((ativo, index) => {
        plTotal += ativo['Aplicação'] || 0
        const val = resolveAssetGroupKey(ativo, group_by)
        if (val) {
          if (!carteira[val]) {
            carteira[val] = { ativos: [] }
          }
          if (!carteira[val].ativos) {
            carteira[val].ativos = []
          }
          if (!carteira[val]['Aplicação']) {
            carteira[val]['Aplicação'] = 0
          }
          if (!carteira[val].color) {
            carteira[val].color = this.getClassColor(val, index)
          }
          carteira[val].ativos.push(ativo)
          carteira[val]['Aplicação'] += ativo['Aplicação'] || 0
          carteira[val].nome = val
        }
      })
      Object.values(carteira).forEach((grupo) => {
        grupo['ROA'] = '-' // Nao calculamos por enquanto
        grupo.final = plTotal
          ? toPercent((grupo['Aplicação'] / plTotal) * 100)
          : ''
        grupo['Aplicação'] = this.formatMoney(grupo['Aplicação'])
      })

      if (!this.filtro_corretora || this.filtro_corretora.length === 0) {
        Object.keys(carteira).forEach((v) => {
          carteira[v].carteira = carteira[v].ativos
        })
        return carteira
      }
      const aux = Object.assign({}, carteira)
      Object.keys(aux).forEach((v) => {
        aux[v].carteira = aux[v].ativos.filter((a) => {
          if (this.modo_filtro_corretora === 'nome_portfolio') {
            return this.filtro_corretora.includes(a.nome_portfolio)
          }
          return (
            this.filtro_corretora.includes(a.corretora) ||
            this.filtro_corretora.includes(a.Corretora)
          )
        })
      })
      const classes = Object.keys(aux)
      classes.forEach((v) => {
        if (!aux[v].carteira.length) {
          delete aux[v]
        }
      })
      return aux || {}
    },
    filteredClasses() {
      if (this.modo_filtro_corretora !== 'subclasse') {
        return Object.values(this.carteiraTabela).map((g, i) => {
          return {
            name: g.nome,
            value: g.final,
            color: g.color,
            pl: getNumber(g['Aplicação']),
          }
        })
      }
      if (!this.result_fracoes) {
        return []
      }
      const aux = this.fundoCompostoExpandido
        ? this.result_fracoes.fracoes_expanded
        : this.result_fracoes.fracoes
      return Object.entries(aux || {})
        .map((v, i) => {
          return {
            name: v[0],
            value: toPercent((v[1].fracao || 0) * 100),
            color: this.getClassColor(v[0], i),
            pl: v[1].pl || 0,
          }
        })
        .sort((a, b) => {
          return getNumber(b.value) - getNumber(a.value)
        })
    },
    allocationColorsByLabel() {
      return buildClassColorMap(
        (this.alocacaoChartOpts && this.alocacaoChartOpts.labels) || []
      )
    },
    suggestedAllocations() {
      const labels =
        (this.alocacaoChartOpts && this.alocacaoChartOpts.labels) || []
      return formatSuggestedAllocations(this.walletAnalysis, labels, {
        expandFundoComposto: this.fundoCompostoExpandido,
      })
    },
    // #TODO: passar para o componente onde é usado
    computedEvolucaoPatrimonial() {
      return formatPatrimonialChart(this.walletAnalysis, {
        primaryColor: this.Color.primary,
      })
    },
    statisticsRentability() {
      return this.walletPortfolioStatistics
    },
    hasClients() {
      return this.clients.length !== 0
    },
    hasSelectedClient() {
      return this.walletScope.ativo
    },
    hasData() {
      if (this.loading || this.loadingClients) return false
      if (this.usuarioAtual.IS_CLIENTE) return !this.hasAssets
      return this.clients.length === 0 || !this.hasAssets
    },
    hasAcess() {
      return typeof this.id_cliente === 'string' ? false : this.id_cliente <= 0
    },
    hasAssets() {
      return hasWalletData(this.walletAnalysis)
    },
    hasClient() {
      return this.walletScope.ativo
    },
    clientNotSelected() {
      if (this.usuarioAtual.IS_CLIENTE) return false
      return !this.walletScope.ativo
    },
    dataOutdated() {
      if (this.walletScope.tipo === 'grupo') return false
      return this.$store.getters['consolidator/clientDataOutdated']
    },
    walletAlertsContext() {
      return {
        screen: 'carteira-atual',
        idCliente: this.id_cliente,
        isClient: !!this.usuarioAtual.IS_CLIENTE,
        isFamilyGroup: !!this.walletScope.grupo,
        walletAnalysis: this.walletAnalysis,
        dataOutdated: this.dataOutdated,
        loading: this.loading,
        loadingClients: this.loadingClients,
        sugestoesPendentesPorAtivo: this.sugestoesPendentesPorAtivo,
      }
    },
    showAssetsReloadLoading() {
      return Boolean(this.dataOutdated) && this.walletAnalysisLoading
    },
    filtersDisabled() {
      return this.loading || this.loadingClients || this.walletAnalysisLoading
    },
    assetTableVisibleColumns() {
      if (!this.usuarioAtual.IS_CLIENTE) return []

      return [
        'ativo',
        'instituicao',
        'saldo_valor',
        'saldo_pct',
        'saldo_data',
        'rent_valor',
        'rent_inicio',
        'rent_data',
        'volatilidade',
      ]
    },
    isLoadingInfoCard() {
      return this.loading || this.loadingClients || this.walletAnalysisLoading
    },
    isLoadingEvolution() {
      return this.loading || this.walletAnalysisLoading
    },
    isLoadingMarketIndicators() {
      return this.loading || this.walletAnalysisLoading
    },
    isLoadingStatisticsCard() {
      return this.loading || this.walletAnalysisLoading
    },
    isLoadingDistribution() {
      return this.loading || this.walletAnalysisLoading
    },
    isLoadingAllocationChart() {
      return this.loading || this.walletAnalysisLoading
    },
    isLoadingAllocationDetails() {
      return (
        this.loading ||
        this.walletAnalysisLoading ||
        !this.filteredClassesWithPerfilFromWallet.length
      )
    },
    isLoadingAssetsDetails() {
      if (this.loading || this.walletAnalysisLoading) return true
      return !this.hasAssets
    },
    requestInvestmentTypeFilter() {
      return this.investmentTypeFilter || 'Todos'
    },
    shouldShowAllocationDetails() {
      const currentFilter = String(
        this.displayInvestmentTypeFilter || ''
      ).toLowerCase()
      const blockedTypes = ['offshore']
      const isBlockedType = blockedTypes.some((type) => {
        return currentFilter.includes(type)
      })
      return !isBlockedType
    },
    displayInvestmentTypeFilter() {
      if (!this.investmentTypeFilter || this.investmentTypeFilter === 'Todos') {
        return ''
      }
      return this.investmentTypeFilter
    },
    filtro_corretora() {
      return this.$store.getters['consolidator/walletFiltersCorretora']
    },
    filtro_data() {
      return this.$store.getters['consolidator/walletFiltersData']
    },
    modo_filtro_corretora() {
      return this.$store.getters['consolidator/walletFiltersModo']
    },
    viewByFilter() {
      return this.$store.getters['consolidator/walletFiltersModo']
    },
    investmentTypeFilter() {
      return this.$store.getters['consolidator/walletFiltersInvestmentType']
    },
    dataInicio() {
      return this.$store.getters['consolidator/walletFiltersDataInicio']
    },
    dataFim() {
      return this.$store.getters['consolidator/walletFiltersDataFim']
    },
    showCustomDate() {
      return this.filtro_data === OPCOES_FILTRO_DATA.ESPECIFICA
    },
    filtro_tipo() {
      return this.$store.getters['consolidator/walletFiltersTipo']
    },
    filtro_subtipo() {
      return this.$store.getters['consolidator/walletFiltersSubtipo']
    },
    filtro_classe() {
      return this.$store.getters['consolidator/walletFiltersClasse']
    },
    filtro_subclasse() {
      return this.$store.getters['consolidator/walletFiltersSubclasse']
    },
    filtro_setor() {
      return this.$store.getters['consolidator/walletFiltersSetor']
    },
    filtro_emissor() {
      return this.$store.getters['consolidator/walletFiltersEmissor']
    },
    filtro_id_conta() {
      return this.$store.getters['consolidator/walletFiltersIdConta']
    },
    filtro_tags() {
      return this.$store.getters['consolidator/walletFiltersTags']
    },
    filtro_instituicao() {
      return this.$store.getters['consolidator/walletFiltersInstituicao']
    },
    filtro_portfolio() {
      return this.$store.getters['consolidator/walletFiltersPortfolio']
    },
    multiFiltersSnapshot() {
      return JSON.stringify({
        tipo: this.filtro_tipo,
        subtipo: this.filtro_subtipo,
        classe: this.filtro_classe,
        subclasse: this.filtro_subclasse,
        setor: this.filtro_setor,
        emissor: this.filtro_emissor,
        idConta: this.filtro_id_conta,
        tags: this.filtro_tags,
        instituicao: this.filtro_instituicao,
        portfolio: this.filtro_portfolio,
      })
    },
    walletAnalysis() {
      return this.$store.getters['consolidator/walletAnalysis']
    },
    walletAnalysisOptionsFields() {
      return this.$store.getters['consolidator/walletAnalysisOptionsFields']
    },
    groupLabelByKey() {
      return buildGroupLabelMap({
        modo: this.modo_filtro_corretora,
        optionsFields: this.walletAnalysisOptionsFields,
      })
    },
    walletAnalysisLoading() {
      return !!this.$store.getters['consolidator/walletAnalysisLoading']
    },
    clienteBenchmarkMeta() {
      return (
        (this.walletAnalysis && this.walletAnalysis.cliente_benchmark_meta) ||
        null
      )
    },
    walletPortfolioStatistics() {
      return (
        (this.walletAnalysis && this.walletAnalysis.portfolio_statistics) ||
        null
      )
    },
    welcomeCardData() {
      const welcomeData = formatWelcomeCardData(this.walletAnalysis)
      if (!welcomeData) return null
      return {
        ...welcomeData,
        nomeCliente: this.clienteAtual.nome_cliente || '',
        temRentabilidade: !!this.walletPortfolioStatistics,
      }
    },
    institutionDistributionChart() {
      return formatInstitutionDistribution(this.walletAnalysis, (name, index) =>
        this.getBankColor(name, index)
      )
    },
    alocacaoEstrategicaChart() {
      return formatAlocacaoEstrategicaChart(
        this.walletAnalysis,
        (name, index) => this.getClassColor(name, index),
        {
          groupBy: this.modo_filtro_corretora,
          groupLabelByKey: this.groupLabelByKey,
        }
      )
    },
    alocacaoChartValues() {
      return this.alocacaoEstrategicaChart.values
    },
    alocacaoChartOpts() {
      return this.alocacaoEstrategicaChart.opts
    },
    rentabilityChart() {
      const benchs = Array.isArray(this.BENCHMARKS) ? this.BENCHMARKS : []
      const selectedIds = Array.isArray(this.benchmarksSelecionados)
        ? this.benchmarksSelecionados
        : []
      const selectedBenchmarks = benchs.filter((b) =>
        selectedIds.includes(b.id)
      )
      return formatRentabilityChart(this.walletAnalysis, {
        primaryColor: this.Color.primary,
        getBankColor: (legend) => this.getBankColor(legend),
        getCorretoraSimple,
        groupBy: this.modo_filtro_corretora,
        groupLabelByKey: this.groupLabelByKey,
        selectedBenchmarks,
        clienteBenchmarkMeta: this.clienteBenchmarkMeta,
        isClienteBenchmarkSelected: selectedIds.includes(CLIENT_BENCHMARK_KEY),
      })
    },
    availableBenchmarkNames() {
      return getAvailableBenchmarkNames(this.walletAnalysis)
    },
    // walletAnalysisWarnings (do WalletWarnings, descontinuado) não é mais
    // necessário — walletAlertsContext.walletAnalysis já carrega
    // walletAnalysis.warnings inteiro, e wallet-alerts-catalog.js lê de lá.
    showOrphanAssetsAlert() {
      return Boolean(this.usuarioAtual && this.usuarioAtual.IS_INTERNAL)
    },
    walletFilterFields() {
      const fields = [{ key: 'modoFiltroCorretora' }]

      if (this.shouldShowBrokerFilter) {
        fields.push({ key: 'filtroCorretora' })
      }

      fields.push({ key: 'investmentTypeFilter' })

      fields.push({
        key: 'filtroData',
        items: [...Object.values(OPCOES_FILTRO_DATA)],
      })

      return fields
    },
    moduleRoutes() {
      return [{ name: 'carteira.minha', title: 'Carteira atual' }]
    },
    showWalletActions() {
      return !this.usuarioAtual.IS_CLIENTE
    },
    walletActions() {
      return [
        {
          label: 'Nova Movimentação',
          icon: 'arrow-swap-horizontal',
          onClick: this.newMovement,
        },
        {
          label: 'Carteira Administrada',
          icon: 'fp-briefcase',
          onClick: this.openModalCarteiraAdministrada,
        },
      ]
    },
  },
  watch: {
    /**
     * A URL manda no cliente da tela — [G-1] do QA da spec-009 (US-7, P1).
     *
     * `immediate` porque o caso da US-7 é o LOAD: sem ele, a tela só reagiria a
     * uma TROCA de rota e o deep link continuaria abrindo o cliente anterior.
     */
    idClienteDaRota: {
      immediate: true,
      handler() {
        this.hidratarClienteDaRota()
      },
    },
    loading(isLoading) {
      if (isLoading || !this.pendingReload) return
      const options = this.pendingReload
      this.pendingReload = null
      this.reload(options)
    },
    usuarioAtual(val) {
      this.reload()
    },
    modo_filtro_corretora(newVal, oldVal) {
      if (!oldVal) return
      this.reload({ skipStatisticsPerAsset: true })
    },
    filtro_corretora(newVal, oldVal) {
      if (!oldVal) return
      this.refreshAfterFilterChange()
    },
    investmentTypeFilter(newVal, oldVal) {
      if (!oldVal) return
      this.handleInvestmentTypeContextChange({ ignoreEmptySpecificDate: true })
    },
    multiFiltersSnapshot(newVal, oldVal) {
      if (newVal === oldVal) return
      this.refreshAfterFilterChange()
    },
    proximaAcaoDesconsiderarVaiMarcar(willMark) {
      const acao = this.acoes_lote_ativos.find(
        (a) => a.field === 'desconsiderar_rentabilidade'
      )
      if (!acao) return
      acao.title = getBulkActionLabel('desconsiderar_rentabilidade', willMark)
    },
  },
  created() {
    // Dispara JUNTO com o resto: e a requisicao mais leve da tela e nao pode esperar a carteira.
    this.carregarSugestoesIa()
    this.carregarFundoCompostoConfigLocal()
    this.preencherAcoesLoteAtivos()
    this.$store.dispatch('subclasse/carregar')
    this.reload()
    this.loadBenchmarks()
    GlobalBus.$on(RELOAD.ASSETS, this.reload)
    if (this.$route && this.$route.params.toBottom) {
      this.scrollBottomInterval = setInterval(() => {
        if (!this.loading) {
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
          })
          clearInterval(this.scrollBottomInterval)
        }
      }, this.SCROLL_BOTTOM_POLL_MS)
      this.scrollBottomTimeout = setTimeout(() => {
        clearInterval(this.scrollBottomInterval)
      }, this.SCROLL_BOTTOM_MAX_WAIT_MS)
    }

    GlobalBus.$on(RELOAD.MANAGE_BENCHMARKS, this.loadBenchmarks)
    GlobalBus.$on(RELOAD.MOVEMENTS, this.verifyMovements)
    GlobalBus.$on(RELOAD.ASSETS_ONLY, this.reloadAssetData)
    GlobalBus.$on(RELOAD.EDIT_ASSET, this.reloadAssetData)
    GlobalBus.$on(RELOAD.CLIENT_CREATED, this.selectCreatedClient)
    GlobalBus.$on(
      RELOAD.CRM_CLIENT_FIELD_UPDATE,
      this.recarregarAoSalvarPerfilDoCliente
    )
  },
  beforeDestroy() {
    GlobalBus.$off(RELOAD.ASSETS, this.reload)
    GlobalBus.$off('changeClient', this.handleClientChange)
    GlobalBus.$off(MODAL.IA_SUGGESTIONS_CHANGED, this.carregarSugestoesIa)
    GlobalBus.$off(RELOAD.IA_CURADORIA, this.carregarSugestoesIa)
    this.bus.$off('editAtivo', this.onEditAtivo)
    clearInterval(this.scrollBottomInterval)
    clearTimeout(this.scrollBottomTimeout)
    GlobalBus.$off(RELOAD.MANAGE_BENCHMARKS, this.loadBenchmarks)
    GlobalBus.$off(RELOAD.MOVEMENTS, this.verifyMovements)
    GlobalBus.$off(RELOAD.ASSETS_ONLY, this.reloadAssetData)
    GlobalBus.$off(RELOAD.EDIT_ASSET, this.reloadAssetData)
    GlobalBus.$off(RELOAD.CLIENT_CREATED, this.selectCreatedClient)
    GlobalBus.$off(
      RELOAD.CRM_CLIENT_FIELD_UPDATE,
      this.recarregarAoSalvarPerfilDoCliente
    )
  },
  mounted() {
    GlobalBus.$on('changeClient', this.handleClientChange)
    GlobalBus.$on(MODAL.IA_SUGGESTIONS_CHANGED, this.carregarSugestoesIa)
    GlobalBus.$on(RELOAD.IA_CURADORIA, this.carregarSugestoesIa)
    this.bus.$on('editAtivo', this.onEditAtivo)
  },
  methods: {
    onEditAtivo() {
      this.reloadAssetData()
    },
    renameStatsByGroupLabels(stats) {
      const labelMap = this.groupLabelByKey
      if (!labelMap) return stats
      if (!stats || Object.keys(labelMap).length === 0) return stats
      const renamed = {}
      for (const key of Object.keys(stats)) {
        if (key === 'Todos') {
          renamed[key] = stats[key]
          continue
        }
        const newKey = labelMap[String(key)] || key
        renamed[newKey] = stats[key]
      }
      return renamed
    },
    /**
     * Entra no cliente que a URL pede — [G-1] do QA da spec-009 (US-7, P1).
     *
     * ★ O que estava errado, e é de uma linha: o `openRouteClient` daqui
     * procurava o cliente com `v.id === id_cliente`, e `id_cliente` vem de
     * `$route.params` — SEMPRE string. `124584 === '124584'` é `false`, então o
     * `find` nunca achava ninguém e a função saía calada. Medido pelo QA no
     * app: com o 138628 persistido, `/c/124584` mantinha a carteira do 138628 na
     * tela — cliente errado sob a URL do certo, sem aviso —, e em store fria não
     * abria cliente nenhum.
     *
     * As três tentativas (store → fetch → inativos) são o util compartilhado
     * com o perfil do cliente (`@utils/cliente-por-id`), a rota de CONTROLE que
     * o QA usou. `navigation/enterClient` (e não `user/addSearchClient` solto)
     * porque um deep link de cliente também entra no CONTEXTO cliente — é o
     * que a barra e o menu leem.
     *
     * A guarda de igualdade cobre `/c/A` com A já corrente (F5, link, aba nova
     * — o CTA dos cartões do chat, `consolidator/ia/acoes.js`, NÃO despacha
     * `enterClient`: quem hidrata é este watcher, na aba nova). Nesse ramo não
     * há o que trocar, mas o param SAI da URL do mesmo jeito (PR #2066): com
     * ele na barra, a troca pelo seletor da topbar deixaria a tela em B e a
     * URL em A.
     */
    async hidratarClienteDaRota() {
      const idDaRota = this.idClienteDaRota
      if (!idDaRota) return

      const atual = this.clienteAtual
      if (atual && String(atual.id) === String(idDaRota)) {
        this.clearRouteClientFromUrl()
        return
      }

      const cliente = await resolverClientePorId(this.$store, idDaRota)
      if (!cliente) {
        this.$showSnack({
          text: 'Cliente não encontrado ou você não tem acesso a ele.',
          button: true,
        })
        return
      }

      this.$store.dispatch('navigation/enterClient', cliente)
      // Os dois canais que a tela já usava para recarregar a carteira do cliente
      // novo (`handleClientChange` escuta o GlobalBus).
      this.bus.$emit('changeClient')
      GlobalBus.$emit('changeClient')
      this.clearRouteClientFromUrl()
    },
    /**
     * O deep link é consumido UMA vez (PR #2066): depois de entrar no cliente, o
     * `/c/:id` sai da URL. A tela troca de cliente pelo seletor da topbar sem
     * navegar — com o param na URL, a tela mostraria B e a URL diria A, e um F5
     * voltaria para A. `replaceState` direto (não `$router.replace`) para não
     * disparar o watcher nem poluir o histórico; mantém o `state` do vue-router.
     */
    clearRouteClientFromUrl() {
      const rotaSemCliente = this.$router.resolve({ name: 'carteira.minha' })
      const href = rotaSemCliente && rotaSemCliente.href
      globalThis.history.replaceState(globalThis.history.state, '', href)
    },
    handleInvestmentTypeContextChange({
      ignoreEmptySpecificDate = false,
    } = {}) {
      this.reloadStatistics({ ignoreEmptySpecificDate })
    },
    // #TODO: passar para o componente onde é usado
    openModalDelete(ativo) {
      GlobalBus.$emit(MODAL.REMOVE_PRODUCT, {
        ativo,
        idCliente: this.id_cliente,
      })
    },
    openNewAtivo(ativo) {
      const asset = ativo && ativo.id ? ativo : {}
      const assetType = normalizeAssetType({ assetData: asset })
      const assetData = { ...asset, Tipo: assetType }
      GlobalBus.$emit(MODAL.CONSOLIDADOR_REGISTER_ASSET, { item: assetData })
    },
    refreshAfterFilterChange() {
      this.loadWalletAnalysis()
      this.carregarBreakdownPorMembro()
    },
    reloadStatistics({ ignoreEmptySpecificDate = false } = {}) {
      if (
        !ignoreEmptySpecificDate &&
        this.filtro_data === OPCOES_FILTRO_DATA.ESPECIFICA &&
        !(this.dataInicio || this.dataFim)
      ) {
        return
      }

      this.loading = true
      this.refreshAfterFilterChange()
      this.loadStatisticsPerAsset()
    },
    normalizeWalletFilters() {
      applyWalletFilterDefaults({
        fields: this.walletFilterFields,
        store: this.$store,
      })
    },
    gerenciarMembrosDoGrupo() {
      if (!this.walletScope.grupo) return this.abrirNovoGrupo()
      GlobalBus.$emit(MODAL.CRM_GRUPO_FAMILIAR_LINK_CLIENT_MODAL, {
        item: { id_grupo_familiar: this.walletScope.grupo.id },
        origem: GRUPO_FAMILIAR_ORIGEM.LISTAGEM,
      })
    },
    editarGrupoAtual() {
      if (!this.walletScope.grupo) return this.abrirNovoGrupo()
      GlobalBus.$emit(MODAL.CRM_GRUPO_FAMILIAR_MODAL, {
        item: this.walletScope.grupo,
        origem: GRUPO_FAMILIAR_ORIGEM.LISTAGEM,
      })
    },
    onAcaoDoGrupo(acao) {
      if (acao && typeof acao.onClick === 'function') acao.onClick()
    },
    abrirExplicacaoDoTotal() {
      GlobalBus.$emit(MODAL.GROUP_TOTAL_EXPLAINER)
    },
    buildWalletAnalysisParams() {
      return buildWalletAnalysisRequest({
        idClienteApp: this.id_cliente,
        usuarioAtual: this.usuarioAtual,
        groupBy: this.modo_filtro_corretora,
        filtroCorretora: this.filtro_corretora,
        modoFiltroCorretora: this.modo_filtro_corretora,
        investmentTypeFilter: this.requestInvestmentTypeFilter,
        showCustomDate: this.showCustomDate,
        filtroData: this.filtro_data,
        OPCOES_FILTRO_DATA,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        enabledFieldKeys: this.enabledWalletFilterKeys,
        tipo: this.filtro_tipo,
        subtipo: this.filtro_subtipo,
        classe: this.filtro_classe,
        subclasse: this.filtro_subclasse,
        setor: this.filtro_setor,
        emissor: this.filtro_emissor,
        idConta: this.filtro_id_conta,
        tags: this.filtro_tags,
        corretora: this.filtro_instituicao,
        nome_portfolio: this.filtro_portfolio,
      })
    },
    carregarBreakdownPorMembro() {
      const grupo = this.walletScope.grupo
      if (!grupo) return
      apiConsolidatorGroupWalletAnalysis.carregarBreakdownPorMembro({
        id_grupo_familiar: grupo.id,
        ...buildGroupBreakdownRequest({
          params: this.buildWalletAnalysisParams(),
        }),
      })
    },
    abrirNovoGrupo() {
      GlobalBus.$emit(MODAL.CRM_GRUPO_FAMILIAR_MODAL, {
        item: {},
        origem: GRUPO_FAMILIAR_ORIGEM.LISTAGEM,
      })
    },
    handleClientChange() {
      this.$store.dispatch('consolidator/resetWalletFilters')
      this.sugestoesDaFila = null
      this.sugestoesPendentesPorAtivo = null
      this.sugestoesPorMovimentacao = null
      // Os ativos e o de-para de movimentacao sao do cliente ANTERIOR. `recomputarSugestoes` filtra
      // a fila pelos ids desta lista, entao deixa-los aqui recorta a fila do cliente novo contra a
      // carteira do antigo ate o `carteira-ativos` reemitir.
      this.ativosDaCarteira = []
      this.movimentacoesDasSugestoes = null
      this.carregarSugestoesIa()
      this.reload({ force: true })
    },
    onWalletAlertAction({ id }) {
      if (id === 'atualizar') this.reload()
      // "Revisar" abre o painel com TODAS as sugestoes do cliente, sem tirar o assessor da tela:
      // o alerta e da CARTEIRA (fala de N ativos), entao o painel vem sem filtro por ativo.
      if (id !== ACAO_SUGESTOES_IA) return
      // Segunda trava, alem do loading do botao: sem os ativos o painel abriria sem nome e com a
      // edicao inerte. Melhor dizer que ainda esta carregando do que entregar um painel inerte.
      if (!this.ativosDaCarteira.length) {
        this.$showSnack({
          text: SUGESTOES_IA_VIEW.carteiraCarregando,
          color: 'info',
          button: true,
        })
        return
      }
      openClientSuggestions({
        cliente: this.clienteAtual,
        ativos: this.ativosDaCarteira,
        movimentacoes: this.movimentacoesDasSugestoes,
      })
    },
    // ★ A fila e carregada AQUI, e nao na tabela: a tabela so monta depois que a carteira responde,
    // entao a requisicao mais LEVE da tela saia ~17s DEPOIS das pesadas (medido: pesadas em 23,5s,
    // fila em 40,1s) e ainda duplicada. Aqui o `id_cliente` existe no created, e ela dispara em
    // paralelo com o resto.
    async carregarSugestoesIa() {
      if (this.walletScope.tipo !== 'cliente') return
      const idClienteApp = idDaCarteira(this.clienteAtual) || this.id_cliente
      const podeVer =
        !!idClienteApp &&
        podeCurarSugestoesIa({ user: this.usuarioAtual, access: this.$access })
      if (!podeVer) {
        this.sugestoesPendentesPorAtivo = null
        this.sugestoesPorMovimentacao = null
        return
      }
      // Chamada concorrente nao pode ser DESCARTADA: quem disparou (troca de cliente, aceite,
      // RELOAD) espera a fila nova. Marca e refaz ao terminar, em vez de sumir com o pedido.
      if (this.carregandoSugestoes) {
        this.sugestoesDesatualizadas = true
        return
      }
      this.carregandoSugestoes = true
      try {
        const r = await apiConsolidatorSuggestions.carregarFila({
          idClienteApp,
        })
        if (!r || r.status !== 200 || !r.value) {
          // A fila CRUA morre junto: `recomputarSugestoes` e chamado tambem quando os ativos e as
          // movimentacoes chegam, e uma fila velha ressuscitaria a contagem de ANTES do aceite.
          this.sugestoesDaFila = null
          this.sugestoesPendentesPorAtivo = null
          this.sugestoesPorMovimentacao = null
          return
        }
        this.sugestoesDaFila = r.value.suggestions
        this.recomputarSugestoes()
      } finally {
        this.carregandoSugestoes = false
        if (this.sugestoesDesatualizadas) {
          this.sugestoesDesatualizadas = false
          this.carregarSugestoesIa()
        }
      }
    },
    // O de-para movimentacao->ativo sai das movimentacoes que a PROPRIA view ja carrega, sem uma
    // segunda ida ao mesmo endpoint. Recomputa quando qualquer um dos dois lados chega.
    // A lista de ativos chega DEPOIS da fila (a carteira e mais pesada). Sem recomputar aqui, a
    // contagem fica com o valor sem guarda que foi apurado antes de a carteira responder.
    onAtivosDaCarteira(lista) {
      this.ativosDaCarteira = lista || []
      this.recomputarSugestoes()
    },
    recomputarSugestoes() {
      const lista = this.sugestoesDaFila
      if (!Array.isArray(lista)) return
      const movimentacoes = indexarMovimentacoes(this.movimentacoes)
      this.movimentacoesDasSugestoes = movimentacoes
      this.sugestoesPendentesPorAtivo = pendentesPorAtivo(lista, {
        movimentacoes,
        ativos: idsDosAtivos(this.ativosDaCarteira),
      })
      this.sugestoesPorMovimentacao = pendentesPorMovimentacao(lista)
    },
    reload(options = {}) {
      if (this.loading && !options.force) {
        this.pendingReload = options
        return
      }
      this.pendingReload = null
      const { skipStatisticsPerAsset = false } = options
      this.collectClients()
      this.clear()
      this.$nextTick(() => {
        if (this.walletScope.ativo) {
          this.normalizeWalletFilters()
          this.loadWalletFilterOptions()
          this.loading = true
          this.verifyMovements()
          this.verifyAutomaticAccounts()
          this.collectFirstLogin()
          this.carregarPerfilDoCliente()
          this.refreshAfterFilterChange()
          if (!skipStatisticsPerAsset) this.loadStatisticsPerAsset()
          this.carregarCarteirasRecomendadasCliente()
        } else {
          this.loading = false
        }
      })
    },
    openOrphanAssetLink({ id } = {}) {
      if (!(this.usuarioAtual && this.usuarioAtual.IS_INTERNAL)) return
      const asset = this.todosAtivosCarteira.find(
        (item) => item && item.id === id
      )
      if (!asset) return
      GlobalBus.$emit(MODAL_IMPORT.MANUAL_QUOTAS, {
        asset,
        cliente: this.clienteAtual,
        forceBaseScope: true,
      })
    },
    async carregarPerfilDoCliente() {
      if (this.walletScope.tipo !== 'cliente') return
      if (this.usuarioAtual.IS_CLIENTE) return
      const idClienteDaRequisicao = this.idClienteApp
      if (!idClienteDaRequisicao) return
      const r = await apiClients.carregarDadosClient({
        id: idClienteDaRequisicao,
      })
      if (this.idClienteApp !== idClienteDaRequisicao) return
      if (!r || r.status !== 200 || !r.value) return
      this.perfilDoCliente = r.value.perfil || null
      this.nomeCadastralDoCliente = r.value.nome_cliente || null
      this.perfilDoClienteCarregado = true
    },
    async abrirEdicaoDoPerfilDoCliente() {
      if (this.walletScope.tipo !== 'cliente') return
      const idClienteApp = this.idClienteApp
      const anchorNome = this.nomeAtualDoCliente
      const currentValue = this.perfilDoCliente
      if (!idClienteApp || !anchorNome) {
        this.$showSnack({
          status: 400,
          text: 'Não foi possível identificar o cliente para definir o perfil.',
        })
        return
      }
      const field = getEditDescriptor({
        fieldKey: 'perfil',
        catalogMeta: { label: 'Perfil' },
      })
      if (!field) return
      await apiPortfolioPortfolioModels.carregar()
      GlobalBus.$emit(MODAL.CRM_EDIT_FIELD, {
        idClienteApp,
        field,
        currentValue,
        anchorNome,
      })
    },
    recarregarAoSalvarPerfilDoCliente({ idClienteApp, field } = {}) {
      if (field !== 'perfil') return
      if (!idClienteApp) return
      if (String(idClienteApp) !== String(this.idClienteApp)) return
      this.reload()
    },
    async carregarCarteirasRecomendadasCliente() {
      if (this.walletScope.tipo !== 'cliente') return
      this.carteirasRecomendadasCliente =
        await apiConsolidatorCarteiraAtivos.carregarCarteirasRecomendadasCliente(
          {
            idCliente: this.id_cliente,
          }
        )
    },
    async collectFirstLogin() {
      if (this.$currentUser().IS_CLIENTE) {
        return
      }
      const res = await con.get(minhaCarteira.first_login)
      if (res && res.status === 200) {
        this.first_login = possivelJSON(res.value.primeiro_login)
      }
    },
    async collectClientDefault() {
      const res = await con.get(minhaCarteira.client_default)
      if (res && res.status === 200) {
        this.id_client_default = possivelJSON(res.value.id_cliente_app)
        this.collectClients(true)
        GlobalBus.$emit(RELOAD.CLIENT_DEFAULT, this.id_client_default)
      }
    },
    collectClients(client_default) {
      if (this.usuarioAtual.IS_CLIENTE) {
        return
      }
      this.loadingClients = true
      con.post(minhaCarteira.listar_clientes).then((r) => {
        if (r.status === 200) {
          this.clients = r.value || []
          this.isClientDefault()
          this.$store.dispatch('user/setClients', r.value || [])
        }
        this.loadingClients = false
      })
    },
    isClientDefault() {
      let cliente_atual =
        Array.isArray(this.clients) &&
        this.clients.find((v) => v.id === this.id_cliente)
      if (!cliente_atual) cliente_atual = {}
      this.client_default = cliente_atual
    },
    clear() {
      this.classes = []
      this.composicao = []
      this.lineChart = {
        labels: [],
        datasets: [],
      }
      this.carteira = {}
      this.estatisticas = []
      this.corretoras = []
      this.corretorasPercent = []
      this.corretorasPie = []
      this.corretorasOpts = {
        ...this.corretorasOpts,
        labels: [],
        colors: ['white'],
      }
      this.hasAssetsAutomatic = false
      this.movimentacoes = {}
      this.lista_mapper_benchmark = []
      this.alertMarcacaoMercadoRF = {}
      this.perfil = null
      this.perfilDoCliente = null
      this.nomeCadastralDoCliente = null
      this.perfilDoClienteCarregado = false
      this.result_fracoes = null
      this.resultFracoesClasse = null
      this.classesExpandido = []
      this.composicaoOptsExpandido = {}
      this.ativos_selecionados = []
      this.mapLinesBenchmarks = {}
      this.benchmarksSelecionados = []
    },
    async loadWalletAnalysis() {
      if (!this.walletScope.ativo) {
        this.loading = false
        return
      }
      const request = claimLatestRequest(this.walletLoadRegistry)
      const params = this.buildWalletAnalysisParams()
      try {
        await apiConsolidatorWalletAnalysis.carregar({
          ...params,
          forceUpdate: true,
        })
        await this.ensureDefaultBenchmarkSelection()
        this.setIncompleteAssets(this.carteiraFromWallet)
        this.setClientWalletDates()
      } finally {
        if (!request.isStale()) {
          this.loading = false
          if (this.walletScope.tipo === 'cliente') {
            this.$store.dispatch('consolidator/setClientDataOutdated', false)
          }
        }
      }
    },
    setClientWalletDates() {
      if (this.walletScope.tipo !== 'cliente') return
      const dates = extractClientWalletDates(this.walletAnalysis)
      this.$store.dispatch('user/setDatas', {
        id_cliente: this.id_cliente,
        data_atualizacao: dates.data_atualizacao,
        data_cotizacao: dates.data_cotizacao,
      })
    },
    setIncompleteAssets(r) {
      if (!this.usuarioAtual.IS_CLIENTE) {
        const has_incomplete = hasIncompleteAssets(
          r,
          BLACK_LIST_CALCULO_RENTABILIDADE
        )
        this.$store.dispatch('user/setClientInfo', {
          has_incompletes_assets: has_incomplete,
        })
      }
      this.$store.dispatch('user/checkIncompleteAsset')
    },
    loadStatisticsPerAsset() {
      if (!this.walletScope.ativo) return
      const params = this.buildWalletAnalysisParams()
      apiConsolidatorStatisticsPerAsset.carregar({
        ...params,
        forceUpdate: true,
      })
      apiConsolidatorAssetSeries.prefetch({
        isClient: this.usuarioAtual.IS_CLIENTE,
        clienteId: this.id_cliente,
      })
    },
    reloadAssetData() {
      this.ativos_selecionados = []
      this.loadWalletFilterOptions()
      this.loadWalletAnalysis()
      this.loadStatisticsPerAsset()
    },
    loadWalletFilterOptions() {
      if (!this.walletScope.ativo) return
      apiConsolidatorWalletAnalysis.loadOptions({
        id_cliente_app: this.clienteAtual.id,
        is_client: this.$currentUser().IS_CLIENTE,
      })
    },
    async resetBenchmarks() {
      this.benchmarksSelecionados = []
      await this.ensureDefaultBenchmarkSelection()
    },
    async ensureDefaultBenchmarkSelection() {
      if (!this.BENCHMARKS || this.BENCHMARKS.length === 0) {
        await apiSettingsBenchmarks.carregar()
      }
      const cdi = (this.BENCHMARKS || []).find((b) => b.nome === 'CDI')
      if (this.clienteBenchmarkMeta) {
        if (!this.benchmarksSelecionados.includes(CLIENT_BENCHMARK_KEY)) {
          this.benchmarksSelecionados.unshift(CLIENT_BENCHMARK_KEY)
        }
        return
      }
      if (cdi && !this.benchmarksSelecionados.includes(cdi.id)) {
        this.benchmarksSelecionados.push(cdi.id)
      }
    },
    async verifyMovements() {
      if (this.walletScope.tipo !== 'cliente') return
      if (this.id_cliente) {
        const data = {
          id_cliente_app: this.id_cliente,
        }
        const url = this.usuarioAtual.IS_CLIENTE
          ? aporte.client.list_grouped
          : aporte.professional.list_grouped
        const r = await con.post(url, data)
        if (r && r.status === 200) {
          const movements = possivelJSON(r.value) || {}
          Object.entries(movements).forEach((v) => {
            v[1].movements = (v[1].movements || []).map((a) => {
              if (
                a.resgate_total &&
                ['Ação', 'Ações', 'FII'].includes(
                  a.tipo || r.value[a.id_ativo_cliente].data.tipo
                )
              ) {
                a.operacao = 'Resgate total'
              } else if (a.resgate_total) {
                a.operacao = 'Resgate total'
                a.valor = getNumber(a.valor) ? a.valor : '-'
                a.valor_unitario = getNumber(a.valor_unitario)
                  ? a.valor_unitario
                  : '-'
              }
              if (a.valor_unitario !== '-') {
                a.valor_unitario = formatNumber(
                  getNumber(a.valor_unitario),
                  decimalLengthPU({
                    tipo: a.tipo || r.value[a.id_ativo_cliente].data.tipo,
                  })
                )
              }
              return a
            })
            v[1].data.corretora = getCorretoraSimple(v[1].data.corretora)
            r.value[v[0]] = { ...v[1], ...v[1].data }
          })
          this.movimentacoes = movements
          this.recomputarSugestoes()
        } else {
          this.movimentacoes = {}
        }
        this.fillAlertMovementsPu()
      }
    },
    handleAllocationViewMode(value) {
      this.allocationViewMode = value
    },
    getClassColor(classe, index) {
      if (this.$store.getters['parameters/classColor']) {
        return this.$store.getters['parameters/classColor'](classe, index)
      }
      return ''
    },
    getBankColor(classe, index) {
      return this.$store.getters['parameters/bankColor'](classe, index)
    },
    formatMoney(v) {
      return toMoney(v)
    },
    // #TODO: passar para o componente onde é usado
    openNewMovement() {
      this.busLeft.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.CADASTRAR_APORTE)
    },
    async verifyAutomaticAccounts() {
      if (this.walletScope.tipo !== 'cliente') return
      let url
      let res
      if (this.usuarioAtual.IS_CLIENTE) {
        url = resgateTotal.resgate_total_contas_automaticas
        res = await con.get(url)
      } else {
        url = resgateTotal.professional.resgate_total_contas_automaticas
        if (this.clienteAtual.id) {
          res = await con.post(url, { id_cliente: this.clienteAtual.id })
        }
      }
      if (res && res.status === 200 && res.value.length > 0) {
        this.openModalResgateTotal(res.value)
      }
    },
    openModalResgateTotal(assets) {
      if (window.SHOW_AUTOMATIC_RESCUE) {
        this.busModal.$emit(MODAL.RESGATE_TOTAL, assets)
      }
    },
    openSelectClient() {
      GlobalBus.$emit(MODAL.CONSOLIDATOR_SELECT_CLIENT)
    },
    abrirImportarExtrato() {
      GlobalBus.$emit(MODAL_IMPORT.EXTRATO_CLIENTES)
    },
    selectCreatedClient(client) {
      if (!client) return
      const createdId = client.id || client.id_cliente || client.id_cliente_app
      if (!createdId) return
      const fromList = (this.clients || []).find((c) => c.id === createdId)
      this.$store.dispatch(
        'user/addSearchClient',
        fromList || {
          ...client,
          id: createdId,
          name: client.name || client.nome_cliente || '',
        }
      )
      GlobalBus.$emit('changeClient')
    },
    openNewClient() {
      this.busLeft.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    /**
     * Verificar ativos que precisam ter o PU/QTD preenchidos para apresentar
     * o botao para redirecionar para tela de movimentacoes.
     * Condicao: Ser RF e ter movimentacoes, sendo alguma sem pu/qtd.
     * Considerando que se esta aparecendo aqui é pq nao teve resgate total ainda.
     */
    fillAlertMovementsPu() {
      const aux = {}

      this.alertMarcacaoMercadoRF = { ...aux }
      return aux
    },
    async checkServices(bus) {
      this.openSendLink(bus)
    },
    openSendLink(bus, id_servico) {
      bus.$emit(MODAL.SEND_LINK, id_servico || '', [this.clienteAtual])
    },
    async enviarEmail(bus) {
      this.checkServices(bus)
    },
    // #TODO: passar para o componente onde é usado
    aporteResgate(asset, operacao) {
      asset.operacao = operacao
      this.busLeft.$emit(
        MODAL.CADASTRAR_APORTE,
        { id: this.clienteAtual.id, name: this.clienteAtual.nome_cliente },
        '',
        asset
      )
    },
    // #TODO: passar para o componente onde é usado
    openSaveBenchmark(classe) {
      const bench = this.lista_mapper_benchmark.find((b) => {
        return classe === b.valor_atributo
      })

      GlobalBus.$emit(MODAL.ADD_BENCHMARK, {
        benchmark: bench || {
          valor_atributo: classe,
          benchmark: '',
        },
        callback: this.receiveNew,
        sugestoes: this.sugestoes,
      })
    },
    // #TODO: passar para o componente onde é usado
    openVincular(origem) {
      GlobalBus.$emit(MODAL.VINCULAR_ATIVO_ESCOLHER, {
        origem: origem,
        id_cliente: this.id_cliente,
      })
    },
    async loadBenchmarks() {
      const url = this.$currentUser().IS_CLIENTE
        ? configuracoes.benchmark.client_manage
        : configuracoes.benchmark.manage
      const r = await con.get(url)

      if (r && r.status === 200 && r.value.length) {
        const aux = {}
        r.value.forEach((b) => {
          aux[b.valor_atributo] = b
        })
        this.mapper_benchmarks = aux
        this.lista_mapper_benchmark = r.value
      } else {
        this.mapper_benchmarks = {}
        this.lista_mapper_benchmark = []
      }
    },
    getClassVolFromWallet(classe, bench_selected, with_bench = true) {
      return formatAllocationVol({
        classe,
        benchSelected: bench_selected,
        withBench: with_bench,
        statistics: this.alocationDataEstatisticsFromWallet,
        benchmarks: this.BENCHMARKS,
        mapperBenchmarks: this.mapper_benchmarks,
      })
    },
    openEvolucaoPatrimonial() {
      this.$router.push({
        name: 'carteira.evolucao',
      })
    },
    selecionarAtivosClasse(ativos, val) {
      if (val) {
        this.ativos_selecionados = [
          ...new Set([
            ...this.ativos_selecionados,
            ...ativos.map((ativo) => ativo.id),
          ]),
        ]
      } else {
        const id_ativos = ativos.map((item) => {
          return item.id
        })
        this.ativos_selecionados = this.listaAtivosSelecionados
          .filter((item) => {
            return !id_ativos.includes(item.id)
          })
          .map((ativo) => ativo.id)
      }
    },
    preencherAcoesLoteAtivos() {
      const show = this.$store.getters['parameters/show'] || {}
      const acoes = []
      if (!this.$currentUser().IS_CLIENTE) {
        acoes.push({
          loading: false,
          action: () => {
            GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
              ativos: this.listaAtivosSelecionados,
              campo: 'subclasse',
            })
          },
          icon: 'mdi-pencil',
          submenu: false,
          title: 'Alterar classe/subclasse',
        })
      }
      acoes.push({
        loading: false,
        action: () => {
          GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
            ativos: this.listaAtivosSelecionados,
            campo: 'instituicao',
          })
        },
        icon: 'mdi-pencil',
        submenu: !this.$currentUser().IS_CLIENTE,
        title: 'Alterar instituição',
      })
      const acaoIsentoIr = {
        loading: false,
        submenu: false,
        icon: 'mdi-currency-usd-off',
        title: 'Isenção IR',
        action: () => this.aplicarFlagEmLote('isento', acaoIsentoIr),
      }
      acoes.push(acaoIsentoIr)
      const acaoIsentoFee = {
        loading: false,
        submenu: false,
        icon: 'mdi-currency-usd-off',
        title: 'Isenção no Fee',
        action: () => this.aplicarFlagEmLote('isento_fee', acaoIsentoFee),
      }
      acoes.push(acaoIsentoFee)
      if (!this.$currentUser().IS_CLIENTE) {
        const acaoDesconsiderarRentabilidade = {
          loading: false,
          submenu: false,
          field: 'desconsiderar_rentabilidade',
          icon: 'mdi-percent',
          title: getBulkActionLabel(
            'desconsiderar_rentabilidade',
            this.proximaAcaoDesconsiderarVaiMarcar
          ),
          action: () =>
            this.aplicarFlagEmLote(
              'desconsiderar_rentabilidade',
              acaoDesconsiderarRentabilidade
            ),
        }
        acoes.push(acaoDesconsiderarRentabilidade)
      }
      acoes.push({
        loading: false,
        action: () => {
          GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
            ativos: this.listaAtivosSelecionados,
            campo: 'portfolio',
          })
        },
        icon: 'mdi-pencil',
        submenu: false,
        title: 'Alterar portfólio',
      })
      acoes.push({
        loading: false,
        action: () => {
          GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
            ativos: this.listaAtivosSelecionados,
            campo: 'excluir',
          })
        },
        icon: 'mdi-delete',
        submenu: false,
        danger: true,
        title: 'Excluir',
      })
      acoes.push({
        loading: false,
        action: () => {
          GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
            ativos: this.listaAtivosSelecionados,
            campo: 'comentario',
          })
        },
        submenu: true,
        icon: 'mdi-pencil',
        title: 'Alterar comentário',
      })
      acoes.push({
        loading: false,
        action: () => {
          GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
            ativos: this.listaAtivosSelecionados,
            campo: 'tag',
          })
        },
        submenu: true,
        icon: 'mdi-plus',
        title: 'Adicionar tag',
      })
      if (
        this.$isWhitelabel() &&
        show.portfolio_review &&
        !this.$currentUser().IS_CLIENTE
      ) {
        acoes.push({
          loading: false,
          action: () => {
            GlobalBus.$emit(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, {
              ativos: this.listaAtivosSelecionados,
              campo: 'simulacao',
            })
          },
          icon: 'mdi-rocket-launch-outline',
          submenu: true,
          title: 'Enviar para simulação',
        })
      }
      this.acoes_lote_ativos = acoes
    },
    async aplicarFlagEmLote(assetField, acao) {
      if (acao && acao.loading) return
      const ativos = this.listaAtivosSelecionados
      if (!ativos.length) return
      if (acao) acao.loading = true
      const startTime = Date.now()
      const request = buildApplyFlagRequest(ativos, assetField)
      const isCliente = this.$currentUser().IS_CLIENTE
      const r = await apiConsolidatorClientAssets.editInBatch({
        idCliente: this.id_cliente,
        idsAtivos: request.idsAtivos,
        dadosAtivo: request.dadosAtivo,
        isCliente,
      })
      const elapsed = Date.now() - startTime
      if (elapsed < 600) {
        await new Promise((resolve) => setTimeout(resolve, 600 - elapsed))
      }
      if (acao) acao.loading = false
      if (r && r.status === 200) {
        GlobalBus.$emit(RELOAD.ASSETS_ONLY, true)
        this.$store.dispatch('consolidator/setClientDataOutdated', true)
      }
      this.$showSnack({
        text: (r && r.message) || 'Erro inesperado',
        button: true,
      })
    },
    salvarFundoCompostoConfigLocal() {
      this.$store.dispatch('parameters/saveConfigLocal', {
        fundoCompostoExpandido: this.fundoCompostoExpandido,
      })
    },
    carregarFundoCompostoConfigLocal() {
      const { fundoCompostoExpandido } =
        this.$store.getters['parameters/config_local'] || {}
      if (typeof fundoCompostoExpandido !== 'undefined') {
        this.fundoCompostoExpandido = fundoCompostoExpandido
      }
    },
    openBenchmark() {
      GlobalBus.$emit(MODAL.BENCHMARK_COMPOSITION)
    },
    openModalCarteiraAdministrada() {
      const currentClient = this.clienteAtual

      GlobalBus.$emit(MODAL.CLIENTS_CARTEIRA_ADMINISTRADA, {
        item: currentClient,
      })
    },
    newMovement() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openAporteResgate')
    },
    onWalletAction(item) {
      if (item && typeof item.onClick === 'function') {
        item.onClick()
      }
    },
    onChangeViewMode(value) {
      this.$store.dispatch('consolidator/setViewMode', value)
    },
  },
}
</script>

<template v-slot:default="{ busLeft }">
  <div>
    <div>
      <WalletAlerts
        :context="walletAlertsContext"
        :ativos-carregando="!ativosDaCarteira.length"
        class="mb-3"
        @action="onWalletAlertAction"
      />

      <OrphanAssetsWarnings
        v-if="showOrphanAssetsAlert"
        :wallet-analysis="walletAnalysis"
        class="mb-3"
        @link-asset="openOrphanAssetLink"
      />

      <ConditionalTeleport to="page-header-actions" :routes="moduleRoutes">
        <BasePageHeader>
          <template v-slot:filter>
            <div data-tour="carteira-minha-filters" class="d-flex align-center">
              <WalletFilters
                :fields="walletFilters"
                :enabled-field-keys="menuWalletFilterKeys"
                :disabled="filtersDisabled"
                @filter="reloadStatistics"
              />
            </div>
          </template>
          <template v-slot:actions>
            <div data-tour="carteira-minha-actions" class="d-flex align-center">
              <BaseSplitButton
                v-if="ehVisaoDeGrupo && acoesDoGrupo.length"
                :label="rotuloAcaoDoGrupo"
                :leading="iconeAcaoDoGrupo"
                :items="acoesDoGrupo"
                @click="gerenciarMembrosDoGrupo"
                @select="onAcaoDoGrupo"
              />
              <BaseButton
                v-else-if="ehVisaoDeGrupo"
                primary
                @click="abrirNovoGrupo"
              >
                Adicionar grupo familiar
              </BaseButton>
              <BaseSplitButton
                v-else-if="showWalletActions"
                label="Cadastrar Ativo"
                leading="plus"
                :items="walletActions"
                @click="openNewAtivo"
                @select="onWalletAction"
              />
            </div>
          </template>
        </BasePageHeader>
      </ConditionalTeleport>

      <!-- "Dados desatualizados" e "Desenquadramento ANBIMA" (spec antiga, alertas
           inline) já são cobertos pelo WalletAlerts unificado (walletAlertsContext)
           acima — ver dados-desatualizados/resolveDesenquadramentoAlert em
           wallet-alerts-catalog.js. WalletWarnings (descontinuado) idem. -->

      <WalletEmptyState
        v-if="hasData"
        :loading="loading"
        :client-not-selected="clientNotSelected"
        :clients-loading="loadingClients"
        :has-selected-client="hasSelectedClient"
        :has-access="hasAcess"
        :has-clients="hasClients"
        :has-assets="hasAssets"
        :has-client="hasClient"
        :is-client-user="usuarioAtual.IS_CLIENTE"
        :movements="movimentacoes"
        :investmentType="displayInvestmentTypeFilter"
        :view-tipo="walletScope.viewTipo"
        :grupo="walletScope.grupo"
        @send-email="enviarEmail(busLeft)"
        @collect-client-default="collectClientDefault"
        @select-client="openSelectClient"
        @open-new-client="openNewClient"
        @new-group="abrirNovoGrupo"
        @new-asset="openNewAtivo"
        @import-assets="abrirImportarExtrato"
        @new-movement="newMovement"
      />

      <v-row v-else>
        <template>
          <v-col cols="12" sm="12" md="12" lg="12">
            <InfoCarteira
              v-if="!ehVisaoDeGrupo"
              :idCliente="id_cliente"
              :loading="isLoadingInfoCard"
              :investmentType="displayInvestmentTypeFilter"
              :readonly="usuarioAtual.IS_CLIENTE"
              :clienteBenchmarkMeta="clienteBenchmarkMeta"
              :welcomeData="welcomeCardData"
              @open-new-movement="openNewMovement"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="7">
            <Evolucao
              :loading="isLoadingEvolution"
              :hasAssetsAutomatic="hasAssetsAutomatic"
              :dataRentabilidade="rentabilityChart"
              :dataPatrimonio="computedEvolucaoPatrimonial"
              :investmentType="displayInvestmentTypeFilter"
              :benchmarks-selecionados="benchmarksSelecionados"
              :benchmarks="BENCHMARKS"
              :cliente-benchmark-meta="clienteBenchmarkMeta"
              :available-benchmark-names="availableBenchmarkNames"
              :show-add-benchmark="!usuarioAtual.IS_CLIENTE"
              :hide-benchmarks="!hasBenchmarks"
              @update:benchmarks-selecionados="benchmarksSelecionados = $event"
              @add-benchmark="openBenchmark"
              @reset="resetBenchmarks"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="5">
            <MercadoIndicadores
              :loading="isLoadingMarketIndicators"
              :benchmarksStatistics="
                walletPortfolioStatistics &&
                walletPortfolioStatistics.benchmarks_statistics
              "
              :brokerData="walletPortfolioStatistics"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="7">
            <Estatisticas
              :loading="isLoadingStatisticsCard"
              :metricas="estatistica"
              :rentabilidade="statisticsRentability"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="5">
            <Distribuicao
              :loading="isLoadingDistribution"
              distribuicaoPor="Instituição"
              :data="institutionDistributionChart"
              :investmentType="displayInvestmentTypeFilter"
            />
          </v-col>
          <v-col v-if="ehVisaoDeGrupo" cols="12" lg="8">
            <GroupWalletTable
              :rows="linhasPorCarteira.rows"
              :totalRow="linhasPorCarteira.totalRow"
              :loading="loading"
              :totalMembersCount="membrosDoGrupo.length"
              :benchmarkLabel="benchmarkDoGrupo"
              @explain-total="abrirExplicacaoDoTotal"
            />
          </v-col>

          <v-col v-if="ehVisaoDeGrupo" cols="12" lg="4">
            <GenericOverviewDonutChart
              :minHeight="280"
              title="Distribuição por Conta"
              :chartData="distribuicaoPorConta"
              :baseKey="GROUP_ACCOUNT_DISTRIBUTION_BASE_KEY"
              :loading="loading"
              useSum
            />
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12">
            <AlocacaoEstrategica
              :loading="isLoadingAllocationChart"
              :valuesChart="alocacaoChartValues"
              :optionsChat="alocacaoChartOpts"
              :investmentType="displayInvestmentTypeFilter"
              :colorsByLabel="allocationColorsByLabel"
              :suggestedValues="suggestedAllocations"
              @update:viewMode="handleAllocationViewMode"
            />
          </v-col>
          <v-col
            v-if="shouldShowAllocationDetails"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <DetalhamentoAlocacaoEstrategica
              :loading="isLoadingAllocationDetails"
              :colorsByLabel="allocationColorsByLabel"
              :alocacaoClienteInvalida="alocacaoClienteInvalidaFromWallet"
              :perfil="perfilFromWallet"
              :statusBalanceamento="statusBalanceamentoFromWallet"
              :temFundoComposto="temFundoCompostoFromWallet"
              :fundoCompostoExpandido="fundoCompostoExpandido"
              :filteredClassesWithPerfil="filteredClassesWithPerfilFromWallet"
              :classesComComposicao="classesComComposicaoFromWallet"
              :alocationDataEstatistics="alocationDataEstatisticsFromWallet"
              :mapClassRent="mapClassRentFromWallet"
              :getClassVol="getClassVolFromWallet"
              :groupBy="modo_filtro_corretora"
              :resultFracoes="resultFracoesFromWallet"
              :resultFracoesClasse="resultFracoesClasseFromWallet"
              :mapperBenchmarks="mapper_benchmarks"
              :viewMode="viewMode"
              :fracoesAnbima="fracoesAnbima"
              :maxAnbimaPorClasse="maxAnbimaPorClasse"
              :statusDesenquadramento="statusDesenquadramento"
              :clienteSemPerfil="clienteSemPerfil"
              :podeDefinirPerfil="podeDefinirPerfil"
              @definir-perfil="abrirEdicaoDoPerfilDoCliente"
              @change-view-mode="onChangeViewMode"
              @changeFundoCompostoExpandido="fundoCompostoExpandido = $event"
              @salvarFundoCompostoConfigLocal="salvarFundoCompostoConfigLocal"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <DetalhamentoCarteiraAtivos
              :columns-config="colunasDaCarteira"
              :sugestoes-pendentes-por-ativo="sugestoesPendentesPorAtivo"
              :sugestoes-por-movimentacao="sugestoesPorMovimentacao"
              :movimentacoes-das-sugestoes="movimentacoesDasSugestoes"
              :carregando-sugestoes="carregandoSugestoes"
              :loading="isLoadingAssetsDetails"
              :reloading="showAssetsReloadLoading"
              :carteira="carteiraFromWallet"
              :groupBy="modo_filtro_corretora"
              :groupLabelByKey="groupLabelByKey"
              :loadingRentAsset="false"
              :allowed-actions="acoesPermitidasNaTabela"
              :readonly="tabelaDeAtivosSomenteLeitura"
              @ativos-planos="onAtivosDaCarteira"
              :statisticsAssets="statisticsAssetsFromWallet"
              :clienteAtual="clienteAtual"
              :ativosSelecionados="ids_ativos_selecionados"
              :modoFiltroCorretora="modo_filtro_corretora"
              :estatisticasClasse="alocationDataEstatisticsFromWallet"
              :composicaoFundos="composicaoFundosFromWallet"
              :movimentacoes="movimentacoes"
              :alertMarcacaoMercadoRF="alertMarcacaoMercadoRF"
              :mapperBenchmarks="mapper_benchmarks"
              :filtroCorretora="filtro_corretora"
              :dataFim="dataFim"
              :benchmarks="BENCHMARKS"
              :investmentType="displayInvestmentTypeFilter"
              :visible-columns="assetTableVisibleColumns"
              :carteirasRecomendadas="carteirasRecomendadasCliente"
              :plTotal="walletPlTotal"
              @selecionarAtivosClasse="selecionarAtivosClasse"
              @openSaveBenchmark="openSaveBenchmark"
              @openNewAtivo="openNewAtivo"
              @aporteResgate="aporteResgate"
              @openVincular="openVincular"
              @openModalDelete="openModalDelete"
              @updateAtivosSelecionados="ativos_selecionados = $event"
            />
          </v-col>
        </template>
      </v-row>
    </div>

    <ModalRemoverAtivo />
    <ConsolidatorSelectClient />
    <DetailsAsset :bus="bus" :bus-left="busLeft" :edit-ativo="openNewAtivo" />

    <ResgateTotal :bus="busModal" />

    <RemoverProduto />

    <AcoesLote
      v-model="ativos_selecionados"
      :acoes="acoes_lote_ativos"
      tipo="ativos"
      tipoSingular="ativo"
    />

    <ModalClientsCarteiraAdministrada />

    <ModalAcoesLoteAtivos />

    <Tour
      v-for="(step, i) in whatsNewSteps"
      :key="`whatsnew-tour-${i}`"
      :steps-tour="whatsNewSteps"
      :current-step="currentTour"
      :disable="currentTour !== i"
      :target-selector="whatsNewTargets[i]"
      @closeTour="closeTour"
      @nextStep="nextTour"
    />

    <OptionsTourManual v-if="!isTourActive" @tour="startTour" />
  </div>
</template>
